import React from 'react';
import classNames from 'classnames';

import { WarningIcon } from 'components/Icons';

import styles from './Warning.module.scss';

const Warning = ({ children, className, ...restProps }: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...restProps} className={classNames(styles.warning, className)}>
    <WarningIcon className={styles.warning_icon} />
    <p className="caption">{children}</p>
  </div>
);

export default Warning;
